// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"156":"6a03d2a7626d88f3","170":"95b8ed122d1fee9f","742":"b460733d464fb1f3"}[chunkId] + ".js";
};